import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungs-typ-rolle-benutzer';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypRolleBenutzerEffects {

    VeranstaltungsTypRolleBenutzer$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGS_TYP_ROLLE_BENUTZER),
        mergeMap((x: ac.GetVeranstaltungsTypRolleBenutzerAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungsTypRolleBenutzer(x.veranstaltungstyp_id, x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungsTypRolleBenutzerErfolgreichAction(result, x.veranstaltungstyp_id, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungsTypRolleBenutzerFehlerAction(error, x.veranstaltungstyp_id, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenQueryService);
        }
        return this.service;
    }
}
